import './css/tailwind.css'
import './css/icon-lingoking.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import BadgeDirective from 'primevue/badgedirective'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'

import { setupInterceptors } from '@lingoking-node-apps/api'
import Design from '@lingoking-node-apps/design-system'
import i18n from '@lingoking-node-apps/i18n'

import { IntercomPlugin } from './plugins/IntercomPlugin'

import { useAuthStore } from '@/stores/auth'

import router from './router'
import App from './App.vue'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(PrimeVue, { unstyled: true, pt: Design })
app.use(ToastService)
app.use(IntercomPlugin)

app.directive('badge', BadgeDirective)
app.directive('tooltip', Tooltip)

// Axios
const { refresh } = useAuthStore()

setupInterceptors(refresh)

app.mount('#app')

export default app
